/*
 * Sacola — botao "Favoritos" (guardar pra depois).
 *
 * Move o item da sacola pros favoritos: garante que o produto esta na wishlist e so entao
 * remove a linha do carrinho. Nao usa toggle direto porque toggle em produto JA favoritado
 * o tiraria da wishlist — o oposto do que o botao promete.
 *
 * Delegacao no document de proposito: o cart.js re-renderiza a lista inteira a cada
 * mudanca de quantidade, entao qualquer listener presos aos botoes morreria no primeiro remove.
 */
(function () {
  var BUSY = 'is-busy';

  function wishlistReady() {
    return typeof StealsWishlist !== 'undefined' && StealsWishlist && typeof StealsWishlist.has === 'function';
  }

  async function saveForLater(button) {
    var productId = button.dataset.productId;
    var handle = button.dataset.productHandle;
    var index = button.dataset.index;
    var items = button.closest('cart-items');
    if (!items || !index) return;

    button.disabled = true;
    button.classList.add(BUSY);

    try {
      if (wishlistReady() && productId && !StealsWishlist.has(productId)) {
        await StealsWishlist.toggle(productId);
        // o cache de handles e o que a pagina /pages/favoritos usa pra montar os cards
        if (handle && window.StealsWishlistHandles) {
          window.StealsWishlistHandles.set(productId, handle);
        }
      }
    } catch (error) {
      // wishlist fora do ar nao pode impedir o item de sair da sacola
      console.error('[steals-cart] nao foi possivel favoritar', error);
    }

    // remove a linha; o cart.js repinta o #CartDrawer-Body e o botao desaparece junto
    items.updateQuantity(index, 0);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-save-for-later]');
    if (!button || button.disabled) return;
    event.preventDefault();
    saveForLater(button);
  });
})();
